// file: src/utils/excelDataFetcher.js

// Fungsi untuk mendapatkan data lokasi dari tb_lokasi
export const getLokasiData = async (id_lokasi) => {
  try {
    const { ref, get } = await import('firebase/database');
    const { database } = await import('../firebase');
    
    const lokasiRef = ref(database, "db_freshpine/tb_lokasi");
    const snapshot = await get(lokasiRef);
    
    if (snapshot.exists()) {
      const lokasiData = snapshot.val();
      const foundLokasi = Object.values(lokasiData).find(
        lokasi => lokasi.id_lokasi === id_lokasi
      );
      return foundLokasi || null;
    }
    return null;
  } catch (error) {
    console.error("Error fetching lokasi data:", error);
    return null;
  }
};

// Fungsi untuk memformat tanggal ke format Excel-friendly
export const formatTanggalExcel = (tanggal) => {
  if (!tanggal || tanggal === '-') return '-';
  
  try {
    const [day, month, year] = tanggal.split('-');
    if (day && month && year) {
      return `${day}/${month}/${year}`; // Format: 17/10/2025
    }
  } catch (error) {
    console.error('Error formatting date:', error);
  }
  return '-';
};

// Fungsi untuk konversi ke Excel serial number (untuk sorting)
export const convertToExcelDate = (dateString) => {
  if (!dateString || dateString === '-') return null;
  
  try {
    const [day, month, year] = dateString.split('-');
    if (day && month && year) {
      // Buat objek Date dengan waktu 12:00:00 untuk menghindari masalah timezone
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), 12, 0, 0);
      
      // Validasi apakah date valid
      if (isNaN(date.getTime())) return null;
      
      // Konversi ke Excel serial number YANG BENAR
      // Excel menggunakan 30 Des 1899 sebagai basis, bukan 1 Jan 1900
      const excelEpoch = new Date(1899, 11, 30); // 30 Desember 1899
      const diffTime = date - excelEpoch;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      
      return diffDays;
    }
  } catch (error) {
    console.error('Error converting date:', error);
  }
  return null;
};

// Fungsi untuk mengkonversi nilai ke number format
export const convertToNumber = (value) => {
  if (!value || value === '-' || value === '') return 0;
  
  // Jika sudah number, return langsung
  if (typeof value === 'number') return value;
  
  // Jika string, coba konversi ke number
  const numValue = parseFloat(value.toString().replace(',', '.'));
  return isNaN(numValue) ? 0 : numValue;
};

// Fungsi untuk parse bibit menjadi varietas, kelas, dan jenis
export const parseBibit = (bibit) => {
  if (!bibit) return { varietas: '', kelas: '', jenis: '' };
  
  // Contoh: "NFMD2SB4"
  // Karakter 3-5: Varietas (index 2,3,4)
  // Karakter 7: Kelas (index 6)
  // Karakter 6: Jenis (index 5) - jika "S" ubah menjadi "SC", selain itu "CR"
  
  let varietas = '';
  let kelas = '';
  let jenis = '';
  
  if (bibit.length >= 7) {
    // Varietas: karakter ke 3-5 (index 2,3,4)
    varietas = bibit.substring(2, 5);
    
    // Jenis: karakter ke 6 (index 5)
    const jenisCode = bibit.charAt(5);
    jenis = jenisCode === 'S' ? 'SC' : 'CR';
    
    // Kelas: karakter ke 7 (index 6)
    kelas = bibit.charAt(6);
  } else if (bibit.length >= 6) {
    // Fallback untuk bibit dengan panjang 6 karakter
    varietas = bibit.substring(2, 5);
    const jenisCode = bibit.charAt(5);
    jenis = jenisCode === 'S' ? 'SC' : 'CR';
    kelas = ''; // Kelas tidak tersedia
  } else if (bibit.length >= 3) {
    // Fallback untuk bibit dengan panjang minimal 3 karakter
    varietas = bibit.substring(2);
    jenis = '';
    kelas = '';
  }
  
  return {
    varietas: varietas,
    kelas: kelas,
    jenis: jenis
  };
};